import { TariffLineItem } from "../TariffLineItem";
import { Checkbox, DataHeader, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffManagement extends Layout {
    checkboxDeficitRating: Checkbox;
    dataHeaderTariffManagement: DataHeader;
    layoutTariffLineItem: TariffLineItem;
    panelTariffManagement: Panel;
    sourceTariffLineItem: DataSource;
    sourceTarrif: DataSource;
    tabTariffDetailsId: Tab;
    tabsetTariffDetails: Tabset;
    textboxDefaultCurrency: Textbox;
    textboxDescription: Textbox;
    textboxDimWeightMultiplier: Textbox;
    textboxEffectiveTimestamp: Textbox;
    textboxExpireTimestamp: Textbox;
    textboxFallbackTariffId: Textbox;
    textboxMinimumWeightPerPallet: Textbox;
    textboxTariffId: Textbox;
    textboxTariffName: Textbox;
    textboxTariffTypeCode: Textbox;
}
